// base
import React from 'react';

import { Button } from '..';
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa';

// assets
import './pager.scss';

const Pager = (props) => {
  const { isFull, currentPage, totalnum, movepage } = props;

  return (
    <div className="pager">
      {
        isFull &&
        <Button className="left_btn" onClick={() => movepage('first')}>
          First
        </Button>
      }
      <Button className="left_btn" onClick={() => movepage('prv')}>
        <FaAngleLeft></FaAngleLeft>
      </Button>
      <div className="pager_items">
        <span className="pager_current">{currentPage}</span>
        <span className="divideLine">/</span>
        <span className="pager_total">{totalnum}</span>
      </div>
      <Button className="right_btn" onClick={() => movepage('next')}>
        <FaAngleRight></FaAngleRight>
      </Button>
      {
        isFull &&
        <Button className="right_btn" onClick={() => movepage('last')}>
          Last
        </Button>
      }
    </div>
  )
};

Pager.defaultProps = {
  isFull: false,
  data: [ 1, 2, 3, 4, 5, 6, 7, 8, 9, 10 ],
  currentPage: 1,
  movepage: () => console.log("page button is pressed"),
};

export default Pager;